import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получить сигналы по фильтру
export const apiGetSignalsFiltered = async (filterName) => {
  const url = `${backendUrl}/api/signals/?filter=${filterName}`;

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(
        `Ошибка сети при получении сигналов по фильтру "${filterName}": ${response.status}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка API фильтрации сигналов:', error);
    throw error;
  }
};